export default {
  tableTent: "Төлбөрийн сонголтууд",
  addPayment: "Чухал сонордуулга",
  downloadTableTent: "Мэдээллийг татаж авах",
  ttips: {
    addPayment:
      "Төлбөрийн брэнд нэмэх хүсэлтээ WEB аппликейшн системд нэвтэрч орно уу. ※Нэвтрэх дансны мэдээлэл мэдээлэгүй бол StarPay тусламжийн дээд цахим шуудантай (03-6555-7777) холбогдоно уу."
  }
};
